<template>
  <div class="contractItem mb_5">
    <div class="contractItem__title">
      <div>商品名稱</div>
      <div>商品<br />代號</div>
      <div>目標保費 <br />繳費方式</div>
      <div>被保險人</div>
      <div>基本保額</div>
      <div>定期保費</div>
      <div>不定期保費<br>(第一次繳費)</div>
    </div>
    <!-- 主約 -->
    <template v-for="(MC, index) in contractData.mc_prod_list">
      <div class="contractItem__MC" :key="'mc_' + index">
        <div class="justify-content-start text-left">{{ MC.prod_name }}</div>
        <div>{{ MC.prod_id }}</div>
        <div>{{ getPay_freq_nm(MC.pay_freq) }}</div>
        <div>{{ truncate(contractData.insured.insured_name) }}</div>
        <div class="justify-content-end">
          {{ formatMethods(MC.amt)
          }}{{ unit_curr(MC.FEATURE_DATA.amt_unit, MC.FEATURE_DATA.curr) }}
        </div>
        <div class="justify-content-end">
          {{ formatMethods(MC.pol_premium)
          }}<span>{{ currTranser(MC.FEATURE_DATA.curr, true) }}</span>
        </div>
        <div class="justify-content-end">
          {{ formatMethods(MC.first_premium)
          }}<span>{{ currTranser(MC.FEATURE_DATA.curr, true) }}</span>
        </div>
        <!--div
          class="justify-content-end text-green text-underline"
          @click="toPaymentPreview()"
        >
          預覽
        </div-->
      </div>
      <!-- 附約 
      <div
        class="contractItem__SC"
        v-for="(SC, index) in MC.sc_prod_list"
        :key="'sc_' + index"
      >
        <div class="justify-content-start text-left">└ {{ SC.prod_name }}</div>
        <div>{{ SC.prod_id }}</div>
        <div></div>
        <div>
          {{
            truncate(SC.insured_name)
          }}
        </div>
        <div class="justify-content-end">
          {{ formatMethods(SC.amt) }}
          {{ unit_curr(SC.amt_unit_nm, SC.curr) }}
        </div>
        <div class="justify-content-end">
          {{ formatMethods(SC.premium) }}{{ SC.premium === "" ? "" : "元" }}
        </div>
      </div>-->
    </template>
   <!-- <div class="contractItem__discountDesc">
      ※點擊「預覽」可瀏覽投資型保費規劃。
      <br />
      ※傳統型附約保費為年繳保費。
    </div> -->
  </div>
</template>

<script>
import mf_Mixin from "@/desktop/views/mf/mixin";
export default {
  mixins: [mf_Mixin],
  props: ["contractData"],
  methods: {
    toPaymentPreview() {
      this.$router.push("/mf/create/createDetailPaymentPreview");
    },
  },
};
</script>

<style lang="scss" scoped>
.contractItem {
  max-width: 904px;
  width: 100%;
  border-radius: 4px;
  border: solid 1px #53c480;
  &__index {
    padding: 15px;
    line-height: 1.38;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 700;
    color: #027a39;
    background-color: #e5f6ec;
  }
  &__title {
    width: 100%;
    display: flex;
    font-weight: 700;
    color: #027a39;
    background-color: #e5f6ec;
    border-top: solid 1px rgba(194, 196, 199, 0.8);
    & > div {
      border: solid 1px rgba(194, 196, 199, 0.8);
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 3px 7px;
    }
    & > div:nth-of-type(1) {
      min-height: 50px;
      width: 32%;
    }
    & > div:nth-of-type(2) {
      width: 6%;
    }
    & > div:nth-of-type(3) {
      width: 11%;
    }
    & > div:nth-of-type(4) {
      width: 13%;
    }
    & > div:nth-of-type(5) {
      width: 10%;
    }
    & > div:nth-of-type(6) {
      width: 13%;
    }
    & > div:nth-of-type(7) {
      width: 15%;
    }
  }
  //主約
  &__MC {
    width: 100%;
    display: flex;
    color: #323a45;
    background-color: #fff;
    border-top: solid 1px rgba(194, 196, 199, 0.8);
    & > div {
      border: solid 1px rgba(194, 196, 199, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 3px 7px;
    }
    & > div:nth-of-type(1) {
      min-height: 50px;
      width: 32%;
    }
    & > div:nth-of-type(2) {
      width: 6%;
    }
    & > div:nth-of-type(3) {
      width: 11%;
    }
    & > div:nth-of-type(4) {
      width: 13%;
    }
    & > div:nth-of-type(5) {
      width: 10%;
    }
    & > div:nth-of-type(6) {
      width: 13%;
    }
    & > div:nth-of-type(7) {
      width: 15%;
    }
  }
  //   附約
  &__SC {
    width: 100%;
    display: flex;
    color: #323a45;
    background-color: #f5f5f5;
    border-top: solid 1px rgba(194, 196, 199, 0.8);
    & > div {
      border: solid 1px rgba(194, 196, 199, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 3px 7px;
    }
    & > div:nth-of-type(1) {
      min-height: 50px;
      width: 40%;
    }
    & > div:nth-of-type(2) {
      width: 6%;
    }
    & > div:nth-of-type(3) {
      width: 11%;
    }
    & > div:nth-of-type(4) {
      width: 13%;
    }
    & > div:nth-of-type(5) {
      width: 15%;
    }
    & > div:nth-of-type(6) {
      width: 15%;
    }
  }
  &__discountDesc {
    border-top: solid 1px rgba(194, 196, 199, 0.8);
    line-height: 1.38;
    padding: 8px 10px;
  }
}
</style>
